var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddbplus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#0071E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.832 31.1663H22.9987C22.6681 31.1663 22.3913 31.0543 22.168 30.8303C21.9448 30.6063 21.8328 30.3295 21.832 29.9997C21.8313 29.6699 21.9433 29.393 22.168 29.169C22.3928 28.945 22.6697 28.833 22.9987 28.833H28.832V22.9997C28.832 22.6691 28.944 22.3922 29.168 22.169C29.392 21.9458 29.6689 21.8338 29.9987 21.833C30.3285 21.8322 30.6058 21.9442 30.8305 22.169C31.0553 22.3938 31.1669 22.6707 31.1654 22.9997V28.833H36.9987C37.3293 28.833 37.6065 28.945 37.8305 29.169C38.0545 29.393 38.1661 29.6699 38.1654 29.9997C38.1646 30.3295 38.0526 30.6067 37.8294 30.8315C37.6061 31.0563 37.3293 31.1679 36.9987 31.1663H31.1654V36.9997C31.1654 37.3302 31.0534 37.6075 30.8294 37.8315C30.6054 38.0555 30.3285 38.1671 29.9987 38.1663C29.6689 38.1656 29.392 38.0536 29.168 37.8303C28.944 37.6071 28.832 37.3302 28.832 36.9997V31.1663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddbplus);
export default __webpack_public_path__ + "static/media/addbplus.773c6d932d9263d0bfad670d509f4b56.svg";
export { ForwardRef as ReactComponent };